import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'element-plus/dist/index.css'; // 引入 Element Plus 的样式

createApp(App).use(store).use(router).mount('#app')
